import { Icon, IconButton, InputAdornment, Stack, TextField } from "@material-ui/core";
import { Form, FormikProvider } from "formik";
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useNovaSenhaFormik } from "../../../pages/usuario/NovaSenha";
import { LoadingButton } from "@material-ui/lab";
import eyeFill from '@iconify/icons-eva/eye-fill';
import eyeOffFill from '@iconify/icons-eva/eye-off-fill';
import { useParams } from "react-router-dom/cjs/react-router-dom";

export default function NovaSenhaForm({ formik }) {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const { values, touched, errors, isSubmitting, handleSubmit, getFieldProps } = formik;

  return (
    <FormikProvider value={formik}>
      <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
        <Stack spacing={3}>
          <TextField
            fullWidth
            autoComplete="new-password"
            type={showPassword ? 'text' : 'password'}
            label="Nova Senha"
            {...getFieldProps('senha')}
            error={Boolean(touched.senha && errors.senha)}
            helperText={touched.senha && errors.senha}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                    <Icon icon={showPassword ? eyeOffFill : eyeFill} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />

          <TextField
            fullWidth
            autoComplete="new-password"
            type={showConfirmPassword ? 'text' : 'password'}
            label="Repetir Senha"
            {...getFieldProps('confirmarSenha')}
            error={Boolean(touched.confirmarSenha && errors.confirmarSenha)}
            helperText={touched.confirmarSenha && errors.confirmarSenha}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={() => setShowConfirmPassword(!showConfirmPassword)} edge="end">
                    <Icon icon={showConfirmPassword ? eyeOffFill : eyeFill} />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </Stack>

        <LoadingButton
          fullWidth
          className="btn-login"
          size="large"
          type="submit"
          variant="contained"
          loading={isSubmitting}
          sx={{ mt: 3 }}
        >
          Salvar nova senha
        </LoadingButton>
      </Form>

      <ToastContainer />
    </FormikProvider>
  );
}
  